import { About } from '@webapp/landing/src/components/ru/about';
import { Safety } from '@webapp/landing/src/components/ru/advantages/safety';
import { Contacts } from '@webapp/landing/src/components/ru/contacts';
import { Agreement } from '@webapp/landing/src/components/ru/docs/agreement';
import { Confidential } from '@webapp/landing/src/components/ru/docs/confidential';
import { CustomCss } from '@webapp/landing/src/components/ru/docs/custom-css';
import { DocsCookie } from '@webapp/landing/src/components/ru/docs/docs-cookie';
import { HookSchema } from '@webapp/landing/src/components/ru/docs/hook-schema';
import { License } from '@webapp/landing/src/components/ru/docs/license';
import { PdPolicy } from '@webapp/landing/src/components/ru/docs/pd-policy';
import { PublicApi } from '@webapp/landing/src/components/ru/docs/public-api';
import { PublicOffer } from '@webapp/landing/src/components/ru/docs/public-offer';
import { Functions } from '@webapp/landing/src/components/ru/functions';
import { Help } from '@webapp/landing/src/components/ru/help';
import { API } from '@webapp/landing/src/components/ru/opportunities/api';
import { Email } from '@webapp/landing/src/components/ru/opportunities/email';
import { HR } from '@webapp/landing/src/components/ru/opportunities/hr';
import { Marketing } from '@webapp/landing/src/components/ru/opportunities/marketing';
import { Tests } from '@webapp/landing/src/components/ru/opportunities/tests';
import { Votes } from '@webapp/landing/src/components/ru/opportunities/votes';
import { PricingPlans } from '@webapp/landing/src/components/ru/pricing/pricing-plans';
import { RespondentPanel } from '@webapp/landing/src/components/ru/respondent-panel';
import { Templates } from '@webapp/landing/src/components/ru/templates';

type Route = {
    path: string;
    title: string;
    children?: Array<Route>;
    component?: any;
};

// TODO purge
export const LandingRoutes: Record<string, Route> = {
    konstruktorForm: {
        path: 'konstruktor-form',
        title: 'Конструктор форм',
    },
    provedenie: {
        path: 'provedenie',
        title: 'Проведение опросов',
        children: [
            {
                path: 'kak-provesti-opros',
                title: 'Как провести допрос?',
            },
        ],
    },
    indeksLoyalnostiNps: {
        path: 'indeks-loyalnosti-nps',
        title: 'Индекс лояльности клиентов NPS',
    },
};

export const StaticLandingRoutes = {
    about: {
        title: 'О сервисе',
        path: 'about',
    },
    help: {
        title: 'Помощь',
        path: 'help',
    },
    blog: {
        title: 'Блог',
        path: 'blog',
    },
    contacts: {
        title: 'Контакты',
        path: 'contacts',
    },
    capabilitiesApi: {
        title: 'API',
        path: 'capabilities-api',
    },
    capabilitiesHr: {
        title: 'Возможности',
        path: 'capabilities-hr',
    },
    capabilitiesMarketing: {
        title: 'Для маркетинга',
        path: 'capabilities-marketing',
    },
    capabilitiesMailing: {
        title: 'E-mail рассылка',
        path: 'capabilities-mailing',
    },
    capabilitiesTests: {
        title: 'Тесты',
        path: 'capabilities-tests',
    },
    capabilitiesVotes: {
        title: 'Голосования',
        path: 'capabilities-votes',
    },
    advantagesSafety: {
        title: 'Преимущества',
        path: 'advantages-safety',
    },
    pricingPlans: {
        title: 'Тарифы',
        path: 'pricing-plans',
    },
    functions: {
        title: 'Функции',
        path: 'functions',
    },
    respondentPanel: {
        title: 'Панель респондентов для онлайн-опросов — быстрый доступ к целевой аудитории | Тестограф',
        path: 'respondent-panel',
    },
    docsPublicOffer: {
        title: 'Оферта',
        path: 'public-offer',
    },
    docsEula: {
        title: 'Пользовательское соглашение (от 13.10.2021)',
        path: 'docs-eula',
    },
    docsLicence: {
        title: 'Шаблон договора',
        path: 'docs-licence',
    },
    docsPrivacyPolicy: {
        title: 'Политика конфиденциальности (актуальность 10.2021)',
        path: 'docs-privacy-policy',
    },
    docsCustomCss: {
        title: 'Пользовательские стили для опросов',
        path: 'docs-custom-css',
    },
    docsPrivateApi: {
        title: 'Публичное апи',
        path: 'docs-private-api',
    },
    docsWebHooks: {
        title: 'Веб-хуки',
        path: 'docs-web-hooks',
    },
    pdPolicy: {
        title: 'Политика ПДн',
        path: 'pd-policy',
    },
    docsCookie: {
        title: 'Политика cookie',
        path: 'docs-cookie',
    },
    templates: {
        title: 'Шаблоны опросов',
        path: 'templates',
    },
};

export const StaticLandingRoutesFlat = {
    [StaticLandingRoutes.about.path]: {
        title: StaticLandingRoutes.about.title,
        component: About,
    },
    [StaticLandingRoutes.help.path]: {
        title: StaticLandingRoutes.help.title,
        component: Help,
    },
    [StaticLandingRoutes.contacts.path]: {
        title: StaticLandingRoutes.contacts.title,
        component: Contacts,
    },
    [StaticLandingRoutes.capabilitiesApi.path]: {
        title: StaticLandingRoutes.capabilitiesApi.title,
        component: API,
    },
    [StaticLandingRoutes.capabilitiesHr.path]: {
        title: StaticLandingRoutes.capabilitiesHr.title,
        component: HR,
    },
    [StaticLandingRoutes.capabilitiesMarketing.path]: {
        title: StaticLandingRoutes.capabilitiesMarketing.title,
        component: Marketing,
    },
    [StaticLandingRoutes.capabilitiesMailing.path]: {
        title: StaticLandingRoutes.capabilitiesMailing.title,
        component: Email,
    },
    [StaticLandingRoutes.capabilitiesTests.path]: {
        title: StaticLandingRoutes.capabilitiesTests.title,
        component: Tests,
    },
    [StaticLandingRoutes.capabilitiesVotes.path]: {
        title: StaticLandingRoutes.capabilitiesVotes.title,
        component: Votes,
    },
    [StaticLandingRoutes.advantagesSafety.path]: {
        title: StaticLandingRoutes.advantagesSafety.title,
        component: Safety,
    },
    [StaticLandingRoutes.pricingPlans.path]: {
        title: StaticLandingRoutes.pricingPlans.title,
        component: PricingPlans,
    },
    [StaticLandingRoutes.functions.path]: {
        title: StaticLandingRoutes.functions.title,
        component: Functions,
    },
    [StaticLandingRoutes.respondentPanel.path]: {
        title: StaticLandingRoutes.respondentPanel.title,
        component: RespondentPanel,
        keywords:
            'панель респондентов, онлайн-панель, респонденты для опросов, целевая аудитория для опроса, доступ к респондентам, оплата за ответы',
    },
    [StaticLandingRoutes.docsPublicOffer.path]: {
        title: StaticLandingRoutes.docsPublicOffer.title,
        component: PublicOffer,
    },
    [StaticLandingRoutes.docsEula.path]: {
        title: StaticLandingRoutes.docsEula.title,
        component: Agreement,
    },
    [StaticLandingRoutes.docsLicence.path]: {
        title: StaticLandingRoutes.docsLicence.title,
        component: License,
    },
    [StaticLandingRoutes.docsPrivacyPolicy.path]: {
        title: StaticLandingRoutes.docsPrivacyPolicy.title,
        component: Confidential,
    },
    [StaticLandingRoutes.docsCustomCss.path]: {
        title: StaticLandingRoutes.docsCustomCss.title,
        component: CustomCss,
    },
    [StaticLandingRoutes.docsPrivateApi.path]: {
        title: StaticLandingRoutes.docsPrivateApi.title,
        component: PublicApi,
    },
    [StaticLandingRoutes.docsWebHooks.path]: {
        title: StaticLandingRoutes.docsWebHooks.title,
        component: HookSchema,
    },
    [StaticLandingRoutes.pdPolicy.path]: {
        title: StaticLandingRoutes.pdPolicy.title,
        component: PdPolicy,
    },
    [StaticLandingRoutes.docsCookie.path]: {
        title: StaticLandingRoutes.docsCookie.title,
        component: DocsCookie,
    },
    [StaticLandingRoutes.templates.path]: {
        title: StaticLandingRoutes.templates.title,
        component: Templates,
    },
};
